import React, { useContext } from 'react'
import { FaLinkedin } from 'react-icons/fa';
import { BsGithub } from "react-icons/bs";
import { motion } from 'framer-motion';
import { PiReadCvLogoFill } from "react-icons/pi";
import { MyContext } from '../contexts/MyContext';
import { useTheme } from '../contexts/ThemeContext';

const SocialIcons = () => {
    const {CVLink} = useContext(MyContext)
    const { isDark } = useTheme();

    const iconClass = `transition-colors text-xl md:text-2xl ${
        isDark
            ? 'text-dark-text-secondary hover:text-dark-brand-primary'
            : 'text-light-text-secondary hover:text-light-brand-primary'
    }`;

    return (
        <nav className='flex gap-4 md:gap-5'>
            <motion.li whileHover={{ scale: 1.2, y: -2 }} className='list-none'>
                <a href={CVLink} target="_blank" rel="noreferrer" className={iconClass} title="CV">
                    <PiReadCvLogoFill />
                </a>
            </motion.li>
            <motion.li whileHover={{ scale: 1.2, y: -2 }} className='list-none'>
                <a href="https://www.linkedin.com/in/zunayed-fahim-858035199/" target="_blank" rel="noreferrer" className={iconClass} title="Linkedin">
                    <FaLinkedin />
                </a>
            </motion.li>
            <motion.li whileHover={{ scale: 1.2, y: -2 }} className='list-none'>
                <a href="https://github.com/zunayedfahim" target="_blank" rel="noreferrer" className={iconClass} title="Github">
                    <BsGithub />
                </a>
            </motion.li>
        </nav>
    )
}

export default SocialIcons
